import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { CallupHead } from 'ThreeTerminal_mobile_dynamic';
import { getWeMediaMainData, getShareSockpuppetAccountDetail, getShareListData } from '../../../../services/api';
import UserInfo from '../../../components/userInfo';
import SwitchTab from '../../../components/switchTab';
import Main from './main';
import FiXbottom from '../../../components/fixBottom';
import styles from './index.css';
import ToBottomNoData from '../../../components/toBottomNoData';
import TwiceShare from '../../../components/twiceShare';
const mainPageType = 'zmt';
const sourcePageType = 'source';
const isVideoShare = (typeof window === 'object' && window.allData && window.allData.isVideoShare) || false;
const isChinese = temp => {
    const reg = /[\u4E00-\u9FA5\uF900-\uFA2D]/;

    if (reg.test(temp)) {
        return true;
    }

    return false;
};
const isNullObject = obj => {
    if (typeof obj !== 'object') return console.error('请传入对象');

    return Object.keys(obj).length > 0;
};

class Content extends React.PureComponent {
    static propTypes = { content: PropTypes.object };

    content = React.createRef();

    state = {
        cid: this.props.content.cid,
        time: this.props.content.time,
        token: this.props.content.token,
        fromType: this.props.content.type,
        list: [],
        data: {},
        userinfo: {},
        type: 'doc',
        page: 1,
        isLoadEnd: false,
        noThisAccount: false, // 是否是下线的
        behavioralControl: {
            attention: 1,
            click: 1,
            icon: 2,
        },
        nav: [
            {
                name: '文章',
                tag: 'doc',
            },
            {
                name: '视频 ',
                tag: 'video',
            },
        ],
    };

    getContentData = async () => {
        const {
            cid,
            type,
            page,
            fromType,
            time,
            token,
            behavioralControl: { click },
            userinfo: { weMediaName = '' },
        } = this.state;
        // 切换tab，数据先置为空

        const result = {
            content: [],
            isEnd: false,
            // fakeCallback
            callback: () => {},
        };

        let params = {};

        if (fromType === 'source') {
            params = {
                tag: type === 'doc' ? 'article' : type,
                page,
                keyword: cid,
                time,
                token,
            };
        } else {
            params = {
                id: cid,
                type,
                page,
            };
        }

        if (fromType === 'source') {
            const data = await getWeMediaMainData(params);
            let userinfo = {};

            const { sub_id, lev, nickname, userimg, introduction, fans_num, follow_num } = data.data ? data.data.userinfo : {};

            const newList =
                data.data && data.data.feeds
                    ? data.data.feeds.list.map(item => ({
                          ...item,
                          url: item.link ? item.link.weburl : '',
                          newsTime: this.formatNewsTimeForDisplay(item.updateTime || ''),
                          type: 'doc',
                      }))
                    : [];

            userinfo = {
                ...data.data.userinfo,
                eAccountId: sub_id,
                level: lev,
                weMediaName: nickname,
                logo: userimg,
                description: introduction,
                fansNum: fans_num,
                unsubNum: follow_num,
            };

            if (newList.length < 10) {
                result.isEnd = true;

                this.setState({
                    isLoadEnd: true,
                });
            }

            if (data.code === 200) {
                result.content = newList;
                this.setState({
                    userinfo,
                    page: page + 1,
                });
            } else {
                console.error(data.msg);
            }
        } else {
            const data = await getShareListData(params);

            if (data.code === 0) {
                const moreDataWithC = Array.isArray(data.data) && data.data.length > 0 ? data.data : [];

                if (moreDataWithC.length < 10) {
                    result.isEnd = true;

                    this.setState({
                        isLoadEnd: true,
                    });
                }
                this.setState({
                    page: page + 1,
                });
                result.content = moreDataWithC.map(item => ({
                    ...item,
                    newsTime: this.formatNewsTimeForDisplay(item.newsTime || ''),
                }));
            }
        }

        if (click === 2) {
            result.content.forEach(item => (item.callUp = 1));
        }

        result.content.forEach(item => (item.source = weMediaName));

        // if(type == 'doc'){

        // }
        if (type === 'doc' && result?.content?.length === 0 && page === 1) {
            this.setState({
                nav: [
                    {
                        name: '视频 ',
                        tag: 'video',
                    },
                ],
            });

            this.tabSwitch('video');
        }

        return result;
    };

    async componentDidMount() {
        const { cid, fromType } = this.state;
        const { content } = this.props;

        // 非稿源号只获取一次马甲号信息
        if (fromType !== 'source' && !isChinese(cid)) {
            try {
                // 获取自媒体账号信息
                const accountInfo = content.sockpuppetInfo;

                if (accountInfo && accountInfo.behavioralControl) {
                    if (accountInfo && accountInfo.online === 0) {
                        document.title = '自媒体主页';
                        this.setState({
                            noThisAccount: true,
                        });
                    } else {
                        this.setState({
                            userinfo: {
                                ...accountInfo,
                                sign: accountInfo && accountInfo.behavioralControl && accountInfo.behavioralControl.icon === 1 ? '大风号' : '',
                            },
                            behavioralControl: {
                                ...accountInfo.behavioralControl,
                            },
                        });
                    }
                }
            } catch (e) {
                console.log(e);
            }
        }

        try {
            const initDocData = await this.getContentData();

            this.setState({
                list: initDocData.content || [],
            });
        } catch (e) {
            console.log(e);
        }
    }

    tabSwitch = type => {
        // isLoadEnd还原, type切换，page重置, list置空
        this.setState({ isLoadEnd: false, page: 1, type, list: [] }, async () => {
            const switchInitData = await this.getContentData();

            this.setState({
                list: switchInitData.content || [],
            });
        });
    };

    formatNewsTimeForDisplay = newsTime => {
        if (!newsTime) return '';

        const date = new Date(newsTime.replace(/-/g, '/'));

        if (Number.isNaN(date.getTime())) return newsTime;

        const threeMonthsAgo = new Date();

        threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);

        return date < threeMonthsAgo ? '' : newsTime;
    };

    mainDom = params => {
        const { level } = params;
        const { list, type, isLoadEnd, cid } = this.state;

        const displayList = list.map(item => ({
            ...item,
            newsTime: this.formatNewsTimeForDisplay(item.newsTime),
        }));

        const mainDom = [];
        const mainProps = {
            type,
            level,
        };

        mainDom.push(<Main key="list" content={displayList} type={type} id={cid} {...mainProps} getMoreFunc={this.getContentData} />);

        if (!isLoadEnd) {
            mainDom.push(<ToBottomNoData key="loading" title="加载中" isMarginTop />);
        } else {
            mainDom.push(<ToBottomNoData key="end" title="已显示全部数据" isMarginTop />);
        }

        return mainDom;
    };

    render() {
        const { list, fromType, userinfo, noThisAccount, behavioralControl, cid, type, nav } = this.state;

        const { eAccountId, level, weMediaName, logo, description } = userinfo || {};

        const pageInfo = {
            type: fromType === 'source' ? sourcePageType : mainPageType,
            id: eAccountId || cid,
            url: '',
            userId: '',
            level,
            fromPage: 'home',
            fromType,
        };

        const callupHeadData = {
            isVideoShare,
            hotKeyword: [
                '这条最新发布的内容，80%的网友都在看',
                '热热热！这条精彩内容，你的朋友们都在看',
                '过去24小时发生了这些好玩的事，点击查看',
                '全网最热新闻出炉，这些事儿你都知道吗？',
                '想不到！今天最火爆的新闻居就是……',
                '这条重磅新闻刚刚发布！快来查看',
                '过去的24小时你错过了这些重要新闻……',
                '今天这条消息，90%的人都不知道！',
            ],
            topClickInfo: {
                behavior: 'action',
                type: 'upopen',
                ref: encodeURIComponent(decodeURIComponent(location.href)),
                kind: fromType === 'source' ? 'main_tag' : 'vampire',
                callupKind: 'default_upopen',
            },
            fixClickInfo: {
                behavior: 'action',
                type: 'grgxfc',
                ref: encodeURIComponent(decodeURIComponent(location.href)),
                kind: fromType === 'source' ? 'main_tag' : 'vampire',
                callupKind: 'default_grgxfc',
            },
            pageInfo,
        };

        const mainParams = {
            pageInfo,
            level,
        };

        const title = weMediaName ? `${weMediaName}的自媒体主页` : '';

        const shareInfo = {
            title,
            img: logo,
            desc: description,
        };

        const newNav = fromType === 'source' ? [nav[0]] : nav;

        return (
            <React.Fragment>
                {noThisAccount ? (
                    <div className={styles.noThisAccount}>
                        暂无此作者，返回<a href="//i.ifeng.com">凤凰网首页</a>
                    </div>
                ) : (
                    <React.Fragment>
                        <TwiceShare content={shareInfo} />
                        <div className={styles.content} ref={this.content}>
                            <CallupHead content={callupHeadData} />
                            {isNullObject(userinfo) ? <UserInfo content={userinfo} pageInfo={pageInfo} /> : null}
                            <div className={styles.space} />
                            <SwitchTab content={newNav} tabSwitch={this.tabSwitch} />
                            <div>{this.mainDom(mainParams)}</div>
                        </div>
                        {list.length > 0 && behavioralControl.attention === 1 ? <FiXbottom pageInfo={pageInfo} /> : null}
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}

export default errorBoundary(Content);
